import { render, staticRenderFns } from "./CardSpotlightNews.vue?vue&type=template&id=3308c879&"
import script from "./CardSpotlightNews.vue?vue&type=script&lang=js&"
export * from "./CardSpotlightNews.vue?vue&type=script&lang=js&"
import style0 from "./CardSpotlightNews.vue?vue&type=style&index=0&id=3308c879&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports